import React from 'react'
import {Grid, Typography} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import profile from '../Images/profile.png'
import Aos from 'aos';
import "aos/dist/aos.css";
import { useEffect } from 'react'
import Path3 from '../Paths/path3'

const useStyles=makeStyles((themes)=>({

    aboutme:{
        backgroundColor:"rgb(235, 235, 235)",
        textAlign:"center",
        borderRadius:"10px",
        boxShadow:"10px 10px 5px rgb(235, 235, 235)",
        paddingBottom:"60px"
    },
    topic:{
        fontSize:"30px",
        paddingTop:"30px",
    
    
    },
    pic:{
        paddingTop:"50px",
        width: "20%",
        margin:"auto",
        paddingBottom:"50px",
        [themes.breakpoints.down('xs')]: {
            width:"60%"
          },
    },
    div:{
        width:"80%",
        textAlign:"center",
        margin:"auto",
        paddingBottom:"50px"
    },
    text:{
        fontFamily:" 'Dosis', sans-serif"
    },
    path3:{
        backgroundColor:"white",
        textAlign:"center",
        paddingLeft:"7.5%",
        paddingRight:"7.5%",
        
    },
    t1:{
        fontSize:"20px"
    },
    development:{
        textAlign:"left",
        marginLeft:"35%",

        [themes.breakpoints.down('xs')]: {
            marginLeft:"20%",
          },
    },
    development2:{
        textAlign:"left",
        marginLeft:"40%",

        [themes.breakpoints.down('xs')]: {
            marginLeft:"20%",
          },
    }
}))


export default function Aboutme(){

    const classes =useStyles();

    useEffect(()=>{
        Aos.init({duration:2000})
    },[])

    return(

        <div id="aboutme">
            <Grid container>
                <Grid item  md={1}></Grid>

                <Grid item xs={12} md={10} className={classes.aboutme}>
                    <Typography className={classes.topic}>About me</Typography>
                    <img alt="Remy Sharp" src={profile} className={classes.pic} data-aos="fade-up"/> 
                    <div className={classes.div} >
                        <Typography data-aos="fade-up" className={classes.text}>
                          Hi ! I am Akash Ekanayaka, a science graduate from University of Colombo Sri Lanka,
                          a software designer and a software developer who has a good knowledge in software engineering.
                          I like to introduce me as a Designer and a Developer who seeks new technologies and try to improve skills
                          in computing. I always enjoy bulding software applications whether it is a mobile app or website or anything simmilar.
                          <br></br>Here are some technologies that I am currently working on.
                        </Typography>
                    </div> 

                    <Grid container>
                        <Grid item md={2}></Grid>
                        <Grid item xs={12} md={4}>
                            <u><h1 className={classes.t1} data-aos="fade-up">Development</h1></u>
                            <div className={classes.development} data-aos="fade-up">
                                <Typography className={classes.text}>• JavaScript</Typography>
                                <Typography className={classes.text}>• Node js</Typography>
                                <Typography className={classes.text}>• React ( Material UI, Bootstrap, Materialize )</Typography>
                                <Typography className={classes.text}>• React Native</Typography>
                                <Typography className={classes.text}>• Python</Typography>
                                <Typography className={classes.text}>• Java ( Android Studio )</Typography>
                            </div>
                        </Grid>   

                        <Grid item xs={12} md={4}>
                            <u><h1 className={classes.t1} data-aos="fade-up">Design</h1></u>
                            <div className={classes.development2} data-aos="fade-up">
                                <Typography className={classes.text}>• Adobe XD</Typography>
                                <Typography className={classes.text}>• Adobe Illustrator</Typography>
                                <Typography className={classes.text}>• Adobe After Effects</Typography>
                                <Typography className={classes.text}>• Adobe Photoshop</Typography>
                            </div>

                        </Grid>    
                        <Grid item md={2}></Grid>
                        <Grid item xs={12} md={12}></Grid>                        
                    </Grid>          
                </Grid>

                <Grid item md={1}></Grid>
                <Grid item xs={12} md={12} className={classes.path3}>
                    <Path3></Path3>
                </Grid>
              
            </Grid>

        </div>
    )
}